import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { Link, Typography } from '@mui/material';

import AccessDenied from '@/components/shared/AccessDenied';
import { email } from '@/config';

const AccessDeclined = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const queryParams = new URLSearchParams(location.search);
  const accountNameParam = queryParams.get('account');
  const accountName = accountNameParam ? atob(accountNameParam) : '';

  return (
    <AccessDenied
      title="Invite Declined"
      description={
        <>
          You have declined the invitation for the{' '}
          <Typography component="span" fontWeight={600}>
            {accountName}
          </Typography>{' '}
          account. If you believe this is an error, reach out to your
          organization’s administrator or contact{' '}
          <Link href={`mailto:${email}`} sx={{ color: 'primary.main' }}>
            {email}
          </Link>{' '}
          for help.
        </>
      }
      actionButtons={{
        primary: {
          label: 'Go Back',
          onClick: () => navigate(-1),
        },
        secondary: {
          label: 'Log Out',
          onClick: () => logout(),
        },
      }}
    />
  );
};

export default AccessDeclined;
